import React from 'react';

interface IProgressBarProps {
  percentage: number;
  width?: number | string;
  height?: number | string;
  fillColor?: string;
}

export const ProgressBar: React.FC<IProgressBarProps> = ({
  percentage,
  width = '100%',
  height = '25px',
  fillColor = Styles.color.primary,
}) => {
  return (
    <svg width={width} height={height}>
      <rect
        x="0"
        y="10"
        rx="5"
        ry="5"
        width="100%"
        height="10"
        style={{ fill: Styles.color.grey.six, opacity: 0.5 }}
      />
      <rect
        x="0"
        y="10"
        rx="5"
        ry="5"
        width={`${percentage}%`}
        height="10"
        style={{ fill: fillColor, transition: 'width 1s' }}
      />
    </svg>
  );
};
